// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"375e8688","213":"4b201927","239":"35e85120","275":"632e3eaf","453":"4e95ca16","455":"dc80afa5","531":"4e59deaa"}[chunkId] + ".chunk.js";
};